var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandPlotBlock310(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1336.34 514.088L1325.23 495.813L1387.58 492.051L1394.57 510.504L1336.34 514.088Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandPlotBlock310);
export default __webpack_public_path__ + "static/media/land_plot_block_310.74e3338358474301b004350858a95a03.svg";
export { ForwardRef as ReactComponent };